"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lodash = _interopRequireDefault(require("lodash.throttle"));

var _reactVirtualized = require("react-virtualized");

var _material = require("@mui/material");

var Table = (0, _material.styled)(_reactVirtualized.Table)({});
var styles = {
  table: {
    margin: function margin(_ref) {
      var spacing = _ref.spacing;
      return spacing(3.75, -3, 0, -3);
    },
    position: 'relative',
    '&::before, &::after': {
      content: '""',
      transition: 'box-shadow 0.3s ease-in-out'
    },
    '& .ReactVirtualized__Table__headerColumn': {
      fontWeight: 'bold',
      color: function color(_ref2) {
        var palette = _ref2.palette;
        return palette.grey.main;
      },
      fontSize: 12,
      textTransform: 'uppercase',
      padding: function padding(_ref3) {
        var spacing = _ref3.spacing;
        return spacing(0, 1.5);
      }
    },
    '& .ReactVirtualized__Table__headerRow': {
      display: 'flex',
      borderBottom: function borderBottom(_ref4) {
        var palette = _ref4.palette;
        return "solid 1px ".concat(palette.divider);
      },
      padding: function padding(_ref5) {
        var spacing = _ref5.spacing;
        return spacing(0, 1.5);
      }
    },
    '& .ReactVirtualized__Table__Grid': {
      '&:focus': {
        outline: 'none'
      },
      paddingTop: function paddingTop(_ref6) {
        var spacing = _ref6.spacing;
        return spacing(1.5);
      }
    },
    '& .ReactVirtualized__Table__row': {
      '&:focus': {
        outline: 'none'
      },
      display: 'flex',
      padding: function padding(_ref7) {
        var spacing = _ref7.spacing;
        return spacing(0, 1.5);
      }
    },
    '& .ReactVirtualized__Table__rowColumn': {
      margin: function margin(_ref8) {
        var spacing = _ref8.spacing;
        return spacing(0.5, 0);
      },
      padding: function padding(_ref9) {
        var spacing = _ref9.spacing;
        return spacing(0, 1.5);
      },
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }
  },
  tableTopShadow: {
    '&::before': {
      content: '""',
      display: 'block',
      position: 'absolute',
      height: 12,
      top: 0,
      zIndex: 1,
      opacity: 0.25,
      width: '100%',
      boxShadow: 'inset 0px 12px 12px -12px #222222'
    }
  },
  tableBottomShadow: {
    '&::after': {
      content: '""',
      display: 'block',
      position: 'absolute',
      height: 12,
      bottom: 0,
      zIndex: 1,
      opacity: 0.25,
      width: '100%',
      boxShadow: 'inset 0px -12px 12px -12px #222222'
    }
  }
};
/**
 * Styled Virtual Table from "react-virtualized" package.
 *
 * @see {@link https://github.com/bvaughn/react-virtualized/blob/master/docs/Table.md} Table documentation
 * @see {@link https://github.com/bvaughn/react-virtualized/blob/master/docs/Column.md} Column documentation
 * @param {object} props
 * @param {number} props.rowCount - Count items of your table source list.
 * @param {number} [props.width=805] - Width of table.
 * @param {number} [props.rowHeight=58] - Height of table row.
 * @param {number} [props.headerHeight=28] - Height of table header row.
 * @param {number} [props.maxVisibleRows=7] - Rows that will visible without scrolling in the table.
 * @param {string} [props.className=''] - Additional class names for Table of react-virtualized.
 * @param {React.ReactNode} props.children - Table Column's component.
 * @param {function ({ clientHeight: number, scrollTop: number, scrollHeight: number }): void} [props.onScroll=undefined] - Callback that called when table is scrolling.
 * @param props.sx
 * @param {boolean} [props.disableShadows=false] - Disable shadow at the top and the bottom that appears on scrolling.
 * @param {boolean} [props.fixedHeight=false] - Set minimum of table height by count of visible rows.
 * @returns {React.ReactNode}
 * @example
 * import { Column } from 'react-virtualized';
 *
 * export const AwesomeHeroes = () => {
 * const heroes = [{ name: 'Luke Skywalker' }, { name: 'Brokenbrick Candygram' }];
 * return (
 *   <VirtualizedTable
 *     rowCount={heroes.length}
 *     rowGetter={useCallback(({ index }) => heroes[index], [heroes])}
 *   >
 *   <Column label="Hero name" dataKey="name" />
 *     </VirtualizedTable>
 *   );
 * }
 */

var VirtualizedTable = /*#__PURE__*/(0, _react.forwardRef)(function (_ref10, ref) {
  var rowCount = _ref10.rowCount,
      _ref10$width = _ref10.width,
      width = _ref10$width === void 0 ? 805 : _ref10$width,
      _ref10$rowHeight = _ref10.rowHeight,
      rowHeight = _ref10$rowHeight === void 0 ? 58 : _ref10$rowHeight,
      _ref10$headerHeight = _ref10.headerHeight,
      headerHeight = _ref10$headerHeight === void 0 ? 28 : _ref10$headerHeight,
      _ref10$maxVisibleRows = _ref10.maxVisibleRows,
      maxVisibleRows = _ref10$maxVisibleRows === void 0 ? 7 : _ref10$maxVisibleRows,
      _ref10$className = _ref10.className,
      className = _ref10$className === void 0 ? '' : _ref10$className,
      children = _ref10.children,
      onScroll = _ref10.onScroll,
      _ref10$disableShadows = _ref10.disableShadows,
      disableShadows = _ref10$disableShadows === void 0 ? false : _ref10$disableShadows,
      _ref10$fixedHeight = _ref10.fixedHeight,
      fixedHeight = _ref10$fixedHeight === void 0 ? false : _ref10$fixedHeight,
      _ref10$sx = _ref10.sx,
      sx = _ref10$sx === void 0 ? [] : _ref10$sx,
      tableProps = (0, _objectWithoutProperties2["default"])(_ref10, ["rowCount", "width", "rowHeight", "headerHeight", "maxVisibleRows", "className", "children", "onScroll", "disableShadows", "fixedHeight", "sx"]);
  var baseRowHeight = typeof rowHeight === 'function' ? rowHeight({
    index: 0
  }) : rowHeight;
  var tableBodyHeight = (fixedHeight ? maxVisibleRows : Math.min(rowCount, maxVisibleRows)) * baseRowHeight;
  var tableGutterTop = 12;
  var tableHeight = tableBodyHeight + headerHeight + tableGutterTop;

  var _useState = (0, _react.useState)({
    top: false,
    bottom: false
  }),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      tableShadows = _useState2[0],
      setTableShadows = _useState2[1];

  var scrollShadowsHandler = (0, _react.useMemo)(function () {
    return (0, _lodash["default"])(function (_ref11) {
      var clientHeight = _ref11.clientHeight,
          scrollHeight = _ref11.scrollHeight,
          scrollTop = _ref11.scrollTop;

      if (scrollHeight < clientHeight) {
        setTableShadows({
          top: false,
          bottom: false
        });
        return;
      }

      setTableShadows({
        top: scrollTop !== 0,
        bottom: scrollTop !== scrollHeight - clientHeight
      });
    }, 300);
  }, []);
  var onScrollHandler = (0, _react.useCallback)(function (event) {
    var isScrollForShadowsEnabled = !disableShadows;

    if (isScrollForShadowsEnabled) {
      scrollShadowsHandler(event);
    }

    if (onScroll) {
      onScroll(event);
    }
  }, [disableShadows, onScroll, scrollShadowsHandler]);
  return /*#__PURE__*/_react["default"].createElement(Table, (0, _extends2["default"])({
    ref: ref,
    sx: [styles.table, tableShadows.top && styles.tableTopShadow, tableShadows.bottom && styles.tableBottomShadow].concat((0, _toConsumableArray2["default"])(Array.isArray(sx) ? sx : [sx])),
    className: className,
    rowHeight: rowHeight,
    headerHeight: headerHeight,
    width: width,
    height: tableHeight,
    rowCount: rowCount,
    onScroll: onScrollHandler
  }, tableProps), children);
});
VirtualizedTable.propTypes = {
  children: _propTypes["default"].node.isRequired,
  className: _propTypes["default"].string,
  disableShadows: _propTypes["default"].bool,
  headerHeight: _propTypes["default"].number,
  maxVisibleRows: _propTypes["default"].number,
  onScroll: _propTypes["default"].func,
  rowCount: _propTypes["default"].number.isRequired,
  rowHeight: _propTypes["default"].number,
  width: _propTypes["default"].number,
  fixedHeight: _propTypes["default"].bool
};
VirtualizedTable.defaultProps = {
  className: '',
  disableShadows: false,
  headerHeight: 28,
  maxVisibleRows: 7,
  onScroll: undefined,
  rowHeight: 58,
  width: 805,
  fixedHeight: false
};

var _default = /*#__PURE__*/(0, _react.memo)(VirtualizedTable);

exports["default"] = _default;